import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import CheckIcon from '@mui/icons-material/Check';

import {featureInterface} from "../../../../interfaces/featureInterface";
import {setShowAddedToTheCartSuccess} from "../../../../actions/groheFunctions";
import {useIsMounted} from "../../../../misc/helperHooks";

const ShopFeatureSuccessMessage = (props) => {

  const [isVisible, setIsVisible] = useState(false);
  const {showAddedToTheCartSuccess, setShowAddedToTheCartSuccess} = props;
  const successElement = useRef(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    if (showAddedToTheCartSuccess) {
      window.setTimeout(() => {
        setIsVisible(true);
        window.setTimeout(() => {
          if (isMounted()) {
            setIsVisible(false);
          }
          window.setTimeout(() => {
            setShowAddedToTheCartSuccess(false)
          }, 300)
        }, 3000)
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddedToTheCartSuccess])

  if (!showAddedToTheCartSuccess) {
    return null
  }

  return (
    <div className={"shop-feature__success grohe-icontext" + (isVisible ? " shop-feature__success--visible" : "")}
         ref={successElement}>
      <CheckIcon fontSize="small"/>
      <span className="grohe-icontext__cell">
        <FormattedMessage id="grohe.feature.addingToCartSuccessfull" />
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {showAddedToTheCartSuccess} = store.groheState;

  return {
    showAddedToTheCartSuccess
  };
};

const mapDispatchToProps = {
  setShowAddedToTheCartSuccess,
};

ShopFeatureSuccessMessage.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopFeatureSuccessMessage)
